import React from "react";
import { connect } from "react-redux";
import { Snackbar, Typography } from "lantmannen-common-widget";
import { uiActions } from "state/ui";

const ConnectedSnackbar = ({ snackbar, closeMessage, ...props }) => {
  return (
    <Snackbar
      text={<Typography variant="span">{snackbar.message}</Typography>}
      onClose={closeMessage}
      open={snackbar.open}
    />
  );
};

const mapStateToProps = state => ({
  snackbar: state.ui.snackbar
});

const mapDispatchToProps = dispatch => ({
  closeMessage: () => dispatch(uiActions.closeMessage())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSnackbar);
